// Module
var code = "<mn-form-html-block flex template=\"vm.formTemplate\" ng-model=\"vm.model['patientForm']\" patient=\"vm.patient\"\r\n                    ng-change=\"vm.autoSaveCall()\" ng-model-options=\"{debounce:400}\" readonly=\"vm.readOnly\" options=\"vm.options\"></mn-form-html-block>\r\n\r\n<!--<div ng-bind=\"vm.model['patientForm']\"></div>-->";
// Exports
module.exports = code;